import {useDisclosure} from '@mantine/hooks'
import {useRouter} from 'next/router'
import {useEffect} from 'react'

export const useNavigationLoading = () => {
  const router = useRouter()
  const [isNavigating, {open: startNavigating, close: stopNavigating}] = useDisclosure(false)

  useEffect(() => {
    const handleRouteChangeComplete = () => {
      stopNavigating()
    }
    router.events.on('routeChangeComplete', handleRouteChangeComplete)
    return () => {
      router.events.off('routeChangeComplete', handleRouteChangeComplete)
    }
  }, [router, stopNavigating])

  useEffect(() => {
    return () => {
      stopNavigating()
    }
  }, [stopNavigating])

  const startNavigation = () => {
    startNavigating()
    setTimeout(() => stopNavigating(), 3000)
  }

  return {
    isNavigating,
    startNavigation,
    stopNavigating
  }
}
